import moment from 'moment';

export const columnsBase = [
    {
        field: 'idVisita',
        headerName: '#',
        flex: 0.6,
        width: 40,
    },
    {
        field: 'tipo',
        headerName: 'Tipo',
        flex: 1,
        width: 80,
    },
    {
        field: 'periodo',
        headerName: 'Periodo',
        flex: 2,
        width: 200,
        valueGetter: (periodo) => { return !!periodo ? moment(periodo).format('MMMM YYYY').toUpperCase() : '-'}
    },
];